export { HEALTH_STATUS } from './health-status'
export { TOPIC, CATEGORIES, emptyTopicDescription } from './topic'
export { TOPIC_TERM_ID, SERIES_TERM_ID, PODCAST_TERM_ID } from './termId'
export { CATEGORIES_COLORS } from './colors'

export const BASE_URL = 'https://editor.hieusuckhoe.com'
